webpackJsonp([80],{

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(831);


/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(133);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(640);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1520]);


// WEBPACK FOOTER //
// app/datetime.en-9f5288f422bde5ec240d.js